import { getCookie, setCookie } from "cookies-next";
import toast from "react-hot-toast";

import ReferralToast from "~/components/ReferralToast";

export const showReferralToast = () => {
	const referralToastShown = getCookie("referralToastShown");

	if (referralToastShown) return;

	toast.custom(<ReferralToast />, {
		position: "bottom-left",
		duration: 15000,
	});

	setCookie("referralToastShown", "true", {
		maxAge: 60 * 60 * 24 * 30, // 30 days
	});
};
